import { AvailableEntries, FooterLinkCategory, NavigationLink } from '../models';

export abstract class NavigationLinkBase implements NavigationLink {
  protected constructor(
    public readonly feature: AvailableEntries,
    public i18n: string,
    public readonly route: string,
    public a11y?: string,
    public readonly category?: FooterLinkCategory,
    public readonly icon?: string,
  ) {}
}
